export enum ForgeViewerEvents {
    INITIALIZED = 'initialized',
    MODEL_LOADED = 'model-loaded',
    MODEL_ADDED = 'model-added',
    OBJECT_TREE_CREATED = 'object-tree-created',
    TEXTURES_LOADED = 'textures-loaded',
    GEOMETRY_LOADED = 'geometry-loaded',
    TOOL_CHANGE = 'tool-changed',
    EXTENSION_LOADED = 'extension-loaded',
    VIEWER_RESIZE = 'viewer-resize',
    DESTROYED = 'destroyed',
    EXTENSION_ACTIVATED = 'extension-activated',
    EXTENSION_DEACTIVATED = 'extension-deactivated',
}

export enum ForgeViewerExtensions {
    BIM_WALK = 'Autodesk.BimWalk',
}
